import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SHARED_IMPORTS } from './shared/shared-imports';

/**
 * Root component: hosts the routed pages, the global loading bar (HTTP requests and route
 * changes) and the toast container used for success / error notifications across the app.
 */
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ...SHARED_IMPORTS],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {}
